(function (window, $) {
    var routes = [
        { url: '/curso-basico-de-tarot', page: 'home' },
        { url: '/curso-basico-de-tarot/aula-gratuita', page: 'freeLecture' },
        { url: '/curso-basico-de-astrologia', page: 'home' },
        { url: '/curso-basico-de-astrologia/aula-gratuita', page: 'freeLecture' },
        { url: '/curso-aspectos-astrologicos', page: 'home' },
        { url: '/curso-aspectos-astrologicos/aula-gratuita', page: 'freeLecture' },
        { url: '/curso-de-pompoarismo', page: 'home' },
        { url: '/curso-de-pompoarismo/aula-gratuita', page: 'freeLecture' },
    ];

    var page = {
        home: function() {
            goDown.init('.introduction__go-down', '#details-section');

            $('.introduction__media').video();
            $('.modal').modal();
            $('.accordion').accordion();
            $('.sell-bar').fixedSellBoxSmall({ freePage: false });
            $('.sidebar-scroll').fixedSidebarScroll();
        },
        freeLecture: function() {
            scrollbarBox.init();
            $('.sell-bar').fixedSellBoxSmall({ freePage: true });
            $('.modal').modal();
            $('.accordion').accordion();
            $('.sidebar-scroll').fixedSidebarScroll();
        }
    };

    $(function() {
        var currentRoute = utils.matchCurrentRoute(routes);

        // run only current page needed functions
        page[currentRoute.page]();
    });

})(window, jQuery);
